module.exports = `:root {
  --primitiveColorNeutral0: #000000;
  --primitiveColorNeutral200: #313131;
  --primitiveColorNeutral900: #e4e4dd;
  --primitiveColorNeutral970: #f7f7f7;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorPurple160: #4a0053;
  --primitiveColorPurple360: #912680;
  --primitiveColorPurple880: #e1dce3;
  --primitiveColorBiscuit780: #d3be96;
  --primitiveColorBiscuit940: #f0ede2;
  --primitiveColorGreen720: #3CC78B;
  --primitiveTypographyTypescaleDesktop1: 3rem;
  --primitiveTypographyTypescaleDesktop2: 2.125rem;
  --primitiveTypographyTypescaleDesktop3: 1.75rem;
  --primitiveTypographyTypescaleDesktop4: 1.25rem;
  --primitiveTypographyTypescaleDesktop5: 1.125rem;
  --primitiveTypographyTypescaleDesktop6: 1.1rem;
  --primitiveTypographyTypescaleDesktop7: 1rem;
  --primitiveTypographyTypescaleDesktop8: 0.9375rem;
  --primitiveTypographyTypescaleDesktop9: 0.875rem;
  --primitiveTypographyTypescaleMobile1: 2rem;
  --primitiveTypographyTypescaleMobile2: 1.5rem;
  --primitiveTypographyTypescaleMobile3: 1.75rem;
  --primitiveTypographyTypescaleMobile4: 1.25rem;
  --primitiveTypographyTypescaleMobile5: 1.125rem;
  --primitiveTypographyTypescaleMobile6: 1.1rem;
  --primitiveTypographyTypescaleMobile7: 1rem;
  --primitiveTypographyTypescaleMobile8: 0.9375rem;
  --primitiveTypographyTypescaleMobile9: 0.875rem;
}
`;